import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthHeaderComponent } from '../shared/auth-header/auth-header.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LEGAL_MENTION_URLS } from 'src/app/constants/document-urls';

@Component({
  selector: 'app-login-page',
  imports: [RouterOutlet, AuthHeaderComponent, TranslocoModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
  private translocoService = inject(TranslocoService);
  currentYear = new Date().getFullYear();

  get conditionsUrl(): string {
    return this.resourceUrl(LEGAL_MENTION_URLS.termsAndConditions);
  }

  get privacyUrl(): string {
    return this.resourceUrl(LEGAL_MENTION_URLS.privacy);
  }

  resourceUrl(urls: Record<string, string>): string {
    const lang = this.translocoService.getActiveLang();
    return urls[lang] ?? urls['en'];
  }
}
